import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RateRequest } from 'src/api/FiretrolApiClient';
import { rateApiClient } from 'src/api/FiretrolApiClientInstances';
import { invalidateFor } from 'src/api/queries/invalidationMap';

export function useCreateJobRate(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (request: RateRequest) =>
      rateApiClient.createJobRate(jobId, request),
    meta: { suppressErrorToast: true, errorContext: 'create job rate' },
    onSettled: () => invalidateFor('jobRate.create', qc, { jobId }),
  });
}

export function useRemoveJobRate(jobId: number) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (rateId: number) => rateApiClient.removeJobRate(rateId),
    meta: { suppressErrorToast: true, errorContext: 'remove job rate' },
    onSettled: () => invalidateFor('jobRate.create', qc, { jobId }),
  });
}
